import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StandbyMessage } from './models/standby-message.interfaces';

@Component({
  selector: 'idp-standby-message',
  templateUrl: './standby-message.component.html',
  styleUrls: ['./standby-message.component.scss']
})
export class StandbyMessageComponent {
  @Input() content: StandbyMessage = {} as StandbyMessage;
  @Output() action = new EventEmitter();

  redirect(link: string) {
    window.open(link);
  }
}
